'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NUMBER_FORMATTERS;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _formatCurrencyWithCode = require('../utils/formatCurrencyWithCode');

var _formatCurrencyWithCode2 = _interopRequireDefault(_formatCurrencyWithCode);

var _NumberTypes = require('../constants/NumberTypes');

var _NumberTypes2 = _interopRequireDefault(_NumberTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NUMBER_FORMATTERS = (_NUMBER_FORMATTERS = {}, _defineProperty(_NUMBER_FORMATTERS, _NumberTypes2.default.DECIMAL, _I18n2.default.formatNumber), _defineProperty(_NUMBER_FORMATTERS, _NumberTypes2.default.CURRENCY, _I18n2.default.formatCurrency), _defineProperty(_NUMBER_FORMATTERS, _NumberTypes2.default.PERCENTAGE, _I18n2.default.formatPercentage), _NUMBER_FORMATTERS);

exports.default = _react2.default.createClass({
  displayName: 'FormattedNumber',

  propTypes: {
    abbreviate: _react.PropTypes.bool,
    abbreviateThreshold: _react.PropTypes.number,
    currencyCode: _react.PropTypes.string,
    precision: _react.PropTypes.number,
    simplifyCurrency: _react.PropTypes.bool,
    stripInsignificantZeros: _react.PropTypes.bool,
    style: _react.PropTypes.oneOf(Object.keys(_NumberTypes2.default).map(function (key) {
      return _NumberTypes2.default[key];
    })),
    unit: _react.PropTypes.string,
    useCurrencyCode: _react.PropTypes.bool,
    value: _react.PropTypes.number.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      simplifyCurrency: false,
      stripInsignificantZeros: true,
      style: _NumberTypes2.default.DECIMAL
    };
  },
  render: function render() {
    var _props = this.props,
        abbreviate = _props.abbreviate,
        abbreviateThreshold = _props.abbreviateThreshold,
        value = _props.value,
        style = _props.style,
        simplifyCurrency = _props.simplifyCurrency,
        stripInsignificantZeros = _props.stripInsignificantZeros,
        useCurrencyCode = _props.useCurrencyCode,
        options = _objectWithoutProperties(_props, ['abbreviate', 'abbreviateThreshold', 'value', 'style', 'simplifyCurrency', 'stripInsignificantZeros', 'useCurrencyCode']);

    var numberFormatter = NUMBER_FORMATTERS[style];

    if (style === _NumberTypes2.default.CURRENCY) {
      console.warn('Using FormattedNumber with the currency style is deprecated. Please use FormattedCurrency instead.');
    }

    if (simplifyCurrency && value % 1 === 0) {
      options.precision = 0;
    }

    if (useCurrencyCode) {
      options.unit = '';
    }

    if (stripInsignificantZeros === false) {
      options.strip_insignificant_zeros = false;
    } else {
      options.strip_insignificant_zeros = true;
    }

    var wrapperAttributes = {};
    if (abbreviate && (typeof abbreviateThreshold !== 'number' || typeof abbreviateThreshold === 'number' && value >= abbreviateThreshold)) {
      wrapperAttributes.title = numberFormatter(value, options);
      options.abbreviate = true;
      options.precision = 0;
    }

    var formattedNumber = numberFormatter(value, options);
    var numberToRender = useCurrencyCode ? (0, _formatCurrencyWithCode2.default)(formattedNumber, options.currencyCode) : formattedNumber;

    return _react2.default.createElement(
      'span',
      wrapperAttributes,
      numberToRender
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.441/js/components/FormattedNumber.js
// module id = 517
// module chunks = 171